module.exports = "void main()\n{\n  vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n  gl_Position = projectionMatrix * mvPosition;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/pages/ocean/shader/ocean.vsh
// module id = uREw
// module chunks = 1